export * from '@firebase/database';
//# sourceMappingURL=index.esm.js.map
